$(window).ready(() => {
    $('.blog-navigation__link[data-category]').click((e) => {
        e.preventDefault();
        e.delegateTarget.classList.add('active');
        const category = e.delegateTarget.dataset.category;
        $(`.blog-navigation__link:not([data-category="${category}"])`).removeClass('active');
        $(`.blog-articles__article:not(.category--${category})`).addClass('hidden');
        $(`.blog-articles__article.category--${category}`).removeClass('hidden');
    })
})